var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSquarePause({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 1.8V16.2C18 17.19 17.19 18 16.2 18H1.8C0.81 18 0 17.19 0 16.2V1.8C0 0.81 0.81 0 1.8 0H16.2C17.19 0 18 0.81 18 1.8Z",
    fill: "#C8C8CB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSquarePause);
export default __webpack_public_path__ + "static/media/SquarePause.67be1b41.svg";
export { ForwardRef as ReactComponent };